module.exports = __webpack_public_path__ + "assets/img/Eimele-1-Landing-Page-w720.3c7feaed.webp";